import { CurrencyOverrideComponent } from './currency/currencyOveride.component';
import { IndustrySelectionComponent } from './industry-selection/industry-selection.component';
import { ShortNumberPipe } from './pipes/short-number.pipe';

export const SharedComponents = [IndustrySelectionComponent, CurrencyOverrideComponent, ShortNumberPipe];
